import { GRID_UNIT } from "../constants/design";

/**
 * @typedef {number|'auto'} Factor
 */

/**
 * @param {Factor} factor
 */
var getSpacing = function getSpacing(factor) {
  if (factor === 'auto') return factor;
  if (typeof factor === 'number') {
    return factor === 0 ? factor : "".concat(GRID_UNIT * factor, "px");
  }
  return '';
};

/**
 * @param {Factor} [f1=1]
 * @param {Factor} [f2]
 * @param {Factor} [f3]
 * @param {Factor} [f4]
 * @returns {string}
 */
export var spacing = function spacing() {
  var f1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var f2 = arguments.length > 1 ? arguments[1] : undefined;
  var f3 = arguments.length > 2 ? arguments[2] : undefined;
  var f4 = arguments.length > 3 ? arguments[3] : undefined;
  return "".concat(getSpacing(f1), " ").concat(getSpacing(f2), " ").concat(getSpacing(f3), " ").concat(getSpacing(f4)).trim();
};